"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const PREFIX = "Container";
exports.classes = {
    fullWidth: `${PREFIX}-fullWidth`
};
exports.Root = (0, styles_1.styled)("div")(() => ({
    /* NOTE: handle iPhone safe area when in landscape mode */
    /*paddingLeft: "env(safe-area-inset-left, 0)",*/
    /*paddingRight: "env(safe-area-inset-right, 0)"*/
    [`&.${exports.classes.fullWidth}`]: {
        width: "100%"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnRhaW5lci9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsaURBQThDO0FBRTlDLE1BQU0sTUFBTSxHQUFHLFdBQVcsQ0FBQztBQUVkLFFBQUEsT0FBTyxHQUFHO0lBQ3JCLFNBQVMsRUFBRSxHQUFHLE1BQU0sWUFBWTtDQUNqQyxDQUFDO0FBRVcsUUFBQSxJQUFJLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsR0FBRyxFQUFFLENBQUMsQ0FBQztJQUN2QywwREFBMEQ7SUFDMUQsZ0RBQWdEO0lBQ2hELGlEQUFpRDtJQUNqRCxDQUFDLEtBQUssZUFBTyxDQUFDLFNBQVMsRUFBRSxDQUFDLEVBQUU7UUFDMUIsS0FBSyxFQUFFLE1BQU07S0FDZDtDQUNGLENBQUMsQ0FBQyxDQUFDIn0=